import {Route, Redirect} from 'react-router-dom';

import D404 from '@ibibo/d404';

import HomePage from '../pages/Onboarding/HomePage';
import VerifyPage from '../pages/Onboarding/VerifyPage';
import DetailsPage from '../pages/Onboarding/DetailsPage';
import UpdatePage from '../pages/Onboarding/UpdatePage';
import Registered from '../pages/Onboarding/Registered';
import Verification from '../pages/Onboarding/Verification';
import Login from '../pages/Login/Login';
import PreRegister from '../pages/PreRegister/PreRegister';
import BlockMobile from '../stories/components/BlockMobile/BlockMobile';
import {updateInitialData, updateLob} from '../store/actions';
import PrivacyPolicy from '../stories/components/PrivacyPolicy/PrivacyPolicy';
import ContactUs from '../stories/components/ContactUs/ContactUs';
import UserAgreement from '../stories/components/UserAgreement/UserAgreement';
import {getLoogedInRedirectUrl, isUserLoggedIn} from '../store/actions/thunk';
import SupplierTerms from '../stories/components/SupplierTerms/SupplierTerms';
import MultiUserOtpVerified from '../pages/OnboardingNew/MultiUserOtpVerified';
import CreateSubUserAccount from '../pages/OnboardingNew/CreateSubUserAccount';

import HomePageNew from '../pages/OnboardingNew/HomePage';
import OtpVerifyNew from '../pages/OnboardingNew/Verify';
import DetailsPageNew from '../pages/OnboardingNew/DetailsPage';
import DocmentUpload from '../pages/OnboardingNew/DocumentUpload';
import MmtLogin from '../pages/OnboardingNew/MmtLogin';
import CreatePassword from '../pages/OnboardingNew/CreatePassword';
import TermsConditions from '../pages/OnboardingNew/TermsCondition';
import AccountSuccess from '../pages/OnboardingNew/AccountSuccess';
import AccountManual from '../pages/OnboardingNew/AccountManual';
import LoginNew from '../pages/OnboardingNew/LoginNew';
import Loyalty from '../pages/Loyalty/Loyalty';
import BookHotels from '../pages/BookHotels/BookHotels';
import Incentive from '../pages/Incentive';
import MultiUserOtp from '../pages/OnboardingNew/MultiUserOtp';
import CreateAccount from '../stories/components/OnboardingNew/GccComponents/CreateAccount/CreateAccount';
import MobileVerification from '../stories/components/OnboardingNew/GccComponents/MobileVerification/MobileVerification';
import PassportUploadDetails from '../stories/components/OnboardingNew/GccComponents/PassportUploadDetails/PassportUploadDetails';
import {getRedirectUrl} from '../store/actions/thunk';

// import Report from '../../../myaccount/src/stories/components/TransactionalReport/Report';
import GstInvoiceReport from '../../../myaccount/src/stories/components/TransactionalReport/GstInvoiceReport/GstInvoiceReport';

import Reports from '../../../myaccount/src/pages/Reports';
const AgentRoutes = [
  {
    path: '/:baseUrl/redirection',
    key: 'Report',
    actionsBeforeRenderOnServer: async ({request}) => await getRedirectUrl(request),
  },
  {
    path: '/:baseUrl/preregister/',
    component: PreRegister,
    key: 'PreRegister',
    showHeader: false,
    showFooter: false,
  },
  {
    path: '/agent/incentive',
    component: Incentive,
    key: 'Incentive',
    showHeader: false,
    showFooter: false,
    exact: true,
    actionsBeforeRenderOnServer: async ({request}) => await isUserLoggedIn(request),
  },
  {
    path: '/agent/home/',
    component: HomePageNew,
    key: 'AgentUserInfoNew',
    showHeader: false,
    showFooter: false,
    exact: true,
    actionsBeforeRenderOnServer: async ({request}) => await getLoogedInRedirectUrl(request),
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const searchQuery = new URLSearchParams(searchString);
      const token = searchQuery.get('t');
      if (token) {
        dispatch(updateInitialData(token, true));
      }
    },
  },
  {
    path: '/agent/home/:lob',
    component: HomePageNew,
    key: 'AgentUserInfoNew',
    showHeader: false,
    showFooter: false,
    exact: true,
    actionsBeforeRenderOnServer: async ({request, state, params, searchString}) => {
      if (params?.lob == 'hotel' || params?.lob == 'flight') {
        return await getLoogedInRedirectUrl(request);
      } else {
        return {
          status: 301,
          redirectUrl: 'https://mypartner.makemytrip.com/agent/home',
        };
      }
    },
    //  actionsBeforeRenderOnServer: async ({request}) => await getLoogedInRedirectUrl(request),
    populateStoreFromUrl: ({params = {}, searchString}, dispatch) => {
      const {lob = ''} = params;

      const searchQuery = new URLSearchParams(searchString);
      const token = searchQuery.get('t');
      if (token) {
        dispatch(updateInitialData(token, true));
      }
      if (lob) {
        dispatch(updateLob(lob));
      }
    },
  },
  {
    path: '/:baseUrl/otpverify',
    component: OtpVerifyNew,
    key: 'AgentVerifyNew',
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/:baseUrl/agencydetails',
    component: DetailsPageNew,
    key: 'AgentDetailsNew',
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/:baseUrl/agencykyc',
    component: DocmentUpload,
    key: 'AgentKycNew',
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/:baseUrl/userpassword',
    component: MmtLogin,
    key: 'AgentPasswordNew',
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/:baseUrl/createpassword',
    component: CreatePassword,
    key: 'AgentCreatePasswordNew',
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/:baseUrl/tnc',
    component: TermsConditions,
    key: 'AgentTnCNew',
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/:baseUrl/success',
    component: AccountSuccess,
    key: 'AccountCreatedSuccessfully',
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/:baseUrl/manual',
    component: AccountManual,
    key: 'AccountCreatedManual',
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/:baseUrl/login/',
    component: LoginNew,
    key: 'AgentLoginNew',
    showHeader: false,
    showFooter: false,
    actionsBeforeRenderOnServer: async ({request}) => await getLoogedInRedirectUrl(request),
  },
  {
    path: '/:baseUrl/subuser/otpverification',
    component: MultiUserOtp,
    key: 'MultiUserOtpScreen',
    showHeader: false,
    showFooter: false,
    actionsBeforeRenderOnServer: async ({request}) => await getLoogedInRedirectUrl(request),
  },
  {
    path: '/agent/home/v1/',
    component: HomePage,
    key: 'AgentUserInfo',
    showHeader: false,
    showFooter: false,
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const searchQuery = new URLSearchParams(searchString);
      const token = searchQuery.get('t');
      if (token) {
        dispatch(updateInitialData(token, true));
      }
    },
    // actionsBeforeRenderOnServer: async({request}) => await getLoogedInRedirectUrl(request)
  },
  {
    path: '/:baseUrl/verify/',
    component: VerifyPage,
    key: 'AgentOTPVerify',
    showHeader: false,
    showFooter: false,
  },
  {
    path: '/:baseUrl/details/',
    component: DetailsPage,
    key: 'AgentDetails',
    showHeader: false,
    showFooter: false,
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const searchQuery = new URLSearchParams(searchString);
    },
  },
  {
    path: '/:baseUrl/update/',
    component: UpdatePage,
    key: 'AgentUpdatePassword',
    showHeader: false,
    showFooter: false,
  },
  {
    path: '/:baseUrl/registered/',
    component: Registered,
    key: 'AgentSuccessfullyRegistered',
    showHeader: false,
    showFooter: false,
  },
  {
    path: '/:baseUrl/verification/',
    component: Verification,
    key: 'AgentToBeVerified',
    showHeader: false,
    showFooter: false,
  },
  {
    path: '/:baseUrl/login/v1/',
    component: Login,
    key: 'AgentLogin',
    showHeader: false,
    showFooter: false,
    actionsBeforeRenderOnServer: async ({request}) => await getLoogedInRedirectUrl(request),
  },
  {
    path: '/:baseUrl/mobile',
    component: BlockMobile,
    showHeader: false,
    showFooter: false,
  },
  {
    path: '/:baseUrl/privacy-policy',
    component: PrivacyPolicy,
    key: 'PrivacyPolicy',
  },
  {
    path: '/:baseUrl/contact-us',
    component: ContactUs,
    key: 'PrivacyPolicy',
  },
  {
    path: '/:baseUrl/user-agreement',
    component: UserAgreement,
    key: 'UserAgreement',
  },
  {
    path: '/:baseUrl/supplier-terms-and-conditions',
    component: SupplierTerms,
    key: 'SupplierTerms',
  },
  {
    path: '/agent/transactionreport/',
    component: Reports,
    key: 'Report',
  },
  {
    path: '/agent/gstinvoice',
    component: GstInvoiceReport,
    key: 'Gst Invoice',
  },
  {
    path: '/:baseUrl/loyalty/hero/',
    component: Loyalty,
    key: 'Loyalty',
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/:baseUrl/mktemail',
    component: BookHotels,
    key: 'Loyalty',
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/agent/upload-license/',
    component: CreateAccount,
    key: 'GccAgentVerifyNew',
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/agent/upload-passport-details/',
    component: PassportUploadDetails,
    key: 'GccAgentVerifyNew',
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/agent/subuser/otpverified/',
    component: MultiUserOtpVerified,
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '/agent/subuser/createaccount/',
    component: CreateSubUserAccount,
    showHeader: false,
    showFooter: false,
    exact: true,
  },
  {
    path: '*',
    component: D404,
    key: 'hotels404',
  },
];

export default AgentRoutes;
